
import React from 'react'; 
import { TabView, TabPanel } from 'primereact/tabview';
import { useSearchParams } from "react-router-dom";

export default function TemplateDemo({tabContentFn, rankingType = 'regular'}) {

    const [searchParams, setSearchParams] = useSearchParams();
    const gameModes = [
        {key: 'overall', displayName: 'Overall'},
        {key: 'moving', displayName: 'Moving'},
        {key: 'nomove', displayName: 'No move'},
        {key: 'nmpz', displayName: 'NMPZ'}
    ];
    const chosenGameMode = searchParams.get("gameMode");
    const gameModeToIndex = (gameMode) => {
        const index = gameModes.map(gameMode=>gameMode.key).indexOf(gameMode)
        return index >= 0 ? index : 0;
    }

    const tabHeaderTemplate = (displayName) => (options) => {
        return (
            <div className="flex align-items-center p-3 game-mode" style={{ cursor: 'pointer' }} onClick={options.onClick}>
                <span className="white-space-nowrap">{displayName}</span>
            </div>
        )
    };

    const tabs = gameModes.map(gameMode => (
        <TabPanel headerTemplate={tabHeaderTemplate(gameMode.displayName)} key={gameMode.key}>
            <div className="m-0">
                {tabContentFn(gameMode, rankingType)}
                {/* <Ranking gameMode={gameMode.key}></Ranking> */}
            </div>
        </TabPanel>
    ));
    
    return (
        <div className="card" style={{'width': '100%'}}>
            <TabView activeIndex={gameModeToIndex(chosenGameMode)}>
                {tabs}
            </TabView>
        </div>
    )
}
